export default {
  npiRow1: '数字化NPI优化了新产品从概念到市场的过程，降低了新产品导入的成本。管理新产品的可制造性的验证，以避免下游延迟，并透视管控产品从设计到制造和质量控制的关键路径。',
  npiRow2: '自动管理个人和团队（包括外部供应链）的任务，资源和职责。',
  npiRow3: '对延误和里程碑风险进行预警，支持快速决策。',
  npiRow4: '通过产品数字化链快速共享决策，以确保项目按计划进行。',
  npiRow5: '利用NPI导入经验来优化制造过程并加快新产品的批量生产。'
}
